/*
 * Copyright (c) 2021-2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: index.tsx
 * Project: mle-client
 * Committed last: 2021/11/7 @ 1249
 * ---
 */

import React    from 'react';
import ReactDOM from 'react-dom';

import './style/index.css';
import 'normalize.css/normalize.css';
import '@blueprintjs/core/lib/css/blueprint.css';
import '@blueprintjs/popover2/lib/css/blueprint-popover2.css';
import '@blueprintjs/select/lib/css/blueprint-select.css';
import '@blueprintjs/table/lib/css/table.css';


import { App }           from './components/App';
import { HistoryRouter } from './components/common/wrapper/MleRouter';
import { history }       from './common/history';

ReactDOM.render(
  <HistoryRouter history={ history }>
    <App/>
  </HistoryRouter>
  , document.querySelector('#root'));
